 <app-main>
        <div class="container app-shell">
            <div class="columns app-layout">
                <div class="column col-2 app-sidebar">
                    <aside-menu teacher={state.teacher}></aside-menu>
                </div>
                <div class="column col-10 app-page">
                    <app-content></app-content>
                </div>
            </div>
        </div>
        <script>
            import AsideMenu from '../../includes/aside-menu/aside-menu.riot';
            import {router} from "@riotjs/route";

            export default {
                state: {
                    teacher: null,
                },
                components: {
                    AsideMenu,
                },
                onBeforeMount() {
                    // Production uses same-origin /api requests so HTTPS traffic is
                    // routed through Nginx. Local development supplies an explicit URL.
                    axios.defaults.baseURL = process.env.SCHOOL_ADMINISTRATION_API_BASE_URL || ''
                    axios.defaults.withCredentials = true
                    this.responseInterceptor = axios.interceptors.response.use(response => {
                        return response;
                    }, error => {
                        if (error.response && error.response.status === 401) {
                            router.push('/#login')
                        }
                        return Promise.reject(error)
                    });

                    this.teacherLoginHandler = () => this.loadTeacher()
                    window.addEventListener('school:teacher-authenticated', this.teacherLoginHandler)

                    if (window.location.hash !== '#login') {
                        this.loadTeacher()
                    }
                },
                onBeforeUnmount() {
                    window.removeEventListener('school:teacher-authenticated', this.teacherLoginHandler)
                    axios.interceptors.response.eject(this.responseInterceptor)
                },
                loadTeacher() {
                    axios.get(`/api/v1/teacher/session/validate`)
                        .then(res => {
                            this.update({
                                teacher: res.data,
                            })
                            if (res.data.mustChangePassword && window.location.hash !== '#password') {
                                router.push('/#password')
                            } else if (res.data.role === 'platform_admin' && (!window.location.hash || window.location.hash === '#')) {
                                router.push('/#platform/schools')
                            }
                        }).catch(e => {
                            console.log(e)
                        });
                }
            }

        </script>
 </app-main>
